<template>
	<v-card>
		<v-card-title>Request Static IP Range</v-card-title>
    	<v-divider class="mx-6 mb-5"></v-divider>
		<v-card-text>
			<v-row class="subtitle-1">
				<v-col cols="12" class="py-1">
					Account Name: {{ available.serviceName }}
				</v-col>
				<v-col cols="12" class="py-1">
					VISP Account ID: {{ available.accountNumber }}
				</v-col>
				<v-col cols="9" class="py-2">
					No. of Static IPs Requesting:
				</v-col>
				<v-col cols="3" class="pl-0">
					<v-text-field
            placeholder="0"
            type="number"
            min="0"
            max="999"
            outlined
						dense
						class="mt-n3"
						v-model="count"
            color="dark"
            @keyup="checkCount"
            autocomplete="off"
                    ></v-text-field>
				</v-col>
				<v-col class="text-right pb-2 pt-0">
					<v-btn @click="sendRequest" class="mr-5 white--text" color="dark" :disabled="disable">Send Request</v-btn>
					<v-btn @click="cancel">Cancel</v-btn>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
export default {
  name: "request-ip",
  data: () => ({
    accountName: "",
    accountID: 0,
    count: 0,
    disable: true
  }),
  methods: {
    sendRequest () {
      let vm = this;

      let payload = {
        accountName: vm.available.userService,
        accountID: vm.available.accountNumber,
        staticIP: vm.count
      };
    

      vm.requestIPRange(payload).then(() => {
        vm.cancel();
      });
    },
    cancel () {
      let vm = this;
      vm.count = 0;
      vm.$emit("cancel");
    },
    checkCount(){
      let vm = this;
        if(vm.count > 999) vm.count = 999;
        else vm.count = vm.count;
    }
  },
  watch:{
    count: function(){
      let vm = this;

      if(parseInt(vm.count) !== 0) vm.disable = false;
      else vm.disable = true;
    }
  }
}
</script>